export default __webpack_public_path__ + "static/media/Inconsolata-Bold.20c54a01.ttf";